import Checkbox from './Checkbox.jsx';

export default Checkbox;



// WEBPACK FOOTER //
// ./src/pages/Search/Main/FilterBar/Filter/filters/Checkbox/index.js